import { render, staticRenderFns } from "./Collect7.vue?vue&type=template&id=72126964&scoped=true&lang=pug&"
import script from "./Collect7.vue?vue&type=script&lang=ts&"
export * from "./Collect7.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72126964",
  null
  
)

export default component.exports